<p class="card-subtitle">
  canceled information text
</p>